<div [@toExpand]="expanded" (@toExpand.done)="animationComplete($event)">
    <ng-content></ng-content>
</div>
